import { Reveal, MaskLineInView } from "./Reveal";

const items = [
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/65e17632bd2b140a_folwac%20apparel.png", alt: "FOLWAC caps, hats and mugs in royal purple, navy, light blue and gold" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/900672ca2adcc171_folwac%20apparel1.png", alt: "FOLWAC navy and light blue hoodie, t-shirt and dress" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/44679033a8e976d0_generated-image%20%2823%29.png", alt: "FOLWAC royal purple and gold t-shirt and dress" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/688b0f52bc64e442_folwac%20apparel3.png", alt: "FOLWAC royal purple and gold hoodie with living water fountain" },
];

export default function Apparel() {
  return (
    <section id="apparel" className="relative py-28 md:py-40 bg-[#0A0710]">
      <div className="absolute -right-32 top-24 w-[480px] h-[380px] rounded-full bg-[#D4AF37]/10 blur-[140px]" />
      <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <span className="inline-block font-mono text-[0.65rem] uppercase tracking-[0.45em] text-[#7DD3FC] border border-[#7DD3FC]/30 rounded-full px-5 py-2" data-testid="apparel-coming-soon">
              Coming Soon
            </span>
          </Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] mt-6 text-white">
            <MaskLineInView>FOLWAC</MaskLineInView>
            <MaskLineInView delay={0.1}><span className="italic text-gold">Kingdom Apparel.</span></MaskLineInView>
          </h2>
          <Reveal delay={0.2}>
            <p className="text-lg text-[#B4ADC1] font-light mt-6 leading-relaxed">
              Wear the witness. Caps, hats, hoodies, tees, dresses and mugs — "Jesus Christ Makes All Things New" (2 Corinthians 5:17).
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="grid sm:grid-cols-2 gap-5 mt-14" data-testid="apparel-grid">
            {items.map((it, i) => (
              <div key={i} className="glass rounded-3xl p-3 overflow-hidden group" data-testid={`apparel-item-${i}`}>
                <img src={it.src} alt={it.alt} loading="lazy" className="w-full rounded-2xl transition-transform duration-700 group-hover:scale-[1.02]" />
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <p className="text-center font-mono text-xs uppercase tracking-[0.3em] text-[#7A708A] mt-10">
            The Kingdom storefront opens soon — stay tuned.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
